export type LogLevel = 'ERROR' | 'WARN' | 'INFO' | 'DEBUG' | 'TRACE';

/** Code de service désignant tous les services à la fois. */
export const ALL_LOG_SERVICES = 'all';

export interface ILogEntry {
  service: string;
  timestamp: string;
  level: LogLevel;
  thread: string;
  logger: string;
  username: string | null;
  ipAddress: string | null;
  message: string;
  stackTrace: string | null;
}

export interface ILogPage {
  entries: ILogEntry[];
  scannedLines: number;
  /** true si la lecture s'est arrêtée au plafond avant le début du fichier */
  truncated: boolean;
}

export interface ILogSource {
  service: string;
  label: string;
  available: boolean;
  lastModified: string | null;
  sizeBytes: number | null;
  /** Jours consultables (yyyy-MM-dd), du plus récent au plus ancien */
  dates: string[];
}

export interface ILogFilters {
  service: string;
  date?: string;
  levels?: LogLevel[];
  q?: string;
  user?: string;
  limit?: number;
}
